function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.593 81.174l-29.11.125s-5.2.408-5.216-2.549l-.259-59.163 34.311-.15A10.68 10.68 0 0170.047 30.08l.173 40.365c.04 5.898-4.729 10.705-10.627 10.729z",
  fill: "#F5F1E3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M58.464 76.744l-27.958.118s-5.255-.251-5.247 1.882c.008 2.133-.251-58.537-.259-60.395-.016-3.208 5.239-3.231 5.239-3.231L58.197 15a10.68 10.68 0 0110.729 10.642l.172 40.366c.032 5.905-4.729 10.713-10.634 10.736z",
  fill: "#4C3C33"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M47.093 52.904c8.645 0 15.653-7.008 15.653-15.654 0-8.645-7.008-15.653-15.653-15.653-8.646 0-15.654 7.008-15.654 15.653 0 8.646 7.008 15.654 15.654 15.654z",
  fill: "#5AA15B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.093 48.41c6.163 0 11.16-4.997 11.16-11.16 0-6.164-4.997-11.16-11.16-11.16-6.164 0-11.16 4.996-11.16 11.16 0 6.163 4.996 11.16 11.16 11.16z",
  fill: "#F9F6E5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M47.093 48.41c6.163 0 11.16-4.997 11.16-11.16 0-6.164-4.997-11.16-11.16-11.16-6.164 0-11.16 4.996-11.16 11.16 0 6.163 4.996 11.16 11.16 11.16z",
  fill: "#F9F6E5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M59.633 68.274l-24.806.11a1.812 1.812 0 01-1.82-1.804L33 65.568a1.812 1.812 0 011.803-1.82l24.806-.11c.996-.007 1.812.8 1.82 1.804l.008 1.012c0 1.004-.808 1.82-1.804 1.82zm-3.593-7.929l-17.692.078a1.543 1.543 0 01-1.553-1.537l-.008-1.53c0-.854.683-1.552 1.538-1.552l17.692-.078c.855 0 1.553.682 1.553 1.537l.008 1.529a1.543 1.543 0 01-1.537 1.553z",
  fill: "#5AA15B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M56.958 37.79c-.478-.901-1.427-.862-1.772-.815a19.952 19.952 0 00-.306-2.643c-.612-3.458-3.835-6.203-7.788-6.203-3.952 0-7.176 2.745-7.787 6.203a21.347 21.347 0 00-.306 2.643c-.345-.047-1.286-.086-1.773.816-.462.87-.078 2.604 1.42 3.153.353.133.635.188.87.211.212.526.479.965.824 1.302.933.902 2.376 1.498 4 1.804-.573.894-1.27 2.086-1.71 3.215a11.122 11.122 0 008.854.031c-.431-1.144-1.074-2.36-1.584-3.262 1.592-.313 3.011-.902 3.937-1.796.345-.33.612-.776.823-1.302a3.36 3.36 0 00.87-.211c1.507-.541 1.89-2.275 1.428-3.145z",
  fill: "#EDB82B"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M50.363 38.34a1.114 1.114 0 100-2.227 1.114 1.114 0 000 2.227zm-1.138 1.198c-.25-.117-.611-.078-.847.29-.055.094-.102.196-.157.298-.07.15-.133.298-.235.385-.423.376-1.364.376-1.788 0-.102-.095-.172-.236-.235-.385a1.522 1.522 0 00-.157-.298c-.235-.368-.596-.408-.847-.29a.654.654 0 00-.337.8c.149.416.431.792.839 1.09.572.424 1.333.463 1.631.463.298 0 1.059-.047 1.631-.463.4-.298.69-.674.832-1.09a.642.642 0 00-.33-.8zM43.83 38.34a1.114 1.114 0 100-2.227 1.114 1.114 0 000 2.227zm-1.459-3.578a.514.514 0 01-.345-.133.515.515 0 01-.04-.737l1.899-2.126a.49.49 0 01.407-.172.542.542 0 01.4.204l1.247 1.631 1.53-1.663a.506.506 0 01.407-.164.53.53 0 01.393.196l1.286 1.615 1.349-1.63a.53.53 0 01.737-.071.53.53 0 01.07.737l-1.764 2.125a.568.568 0 01-.408.188.524.524 0 01-.408-.196L47.83 32.92l-1.538 1.67a.474.474 0 01-.407.166.513.513 0 01-.393-.204l-1.247-1.624-1.474 1.655a.556.556 0 01-.4.18z",
  fill: "#4C3C33"
});

var SvgAppiconPassport = function SvgAppiconPassport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppiconPassport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appicon-passport.ae3043fd.svg";
export { ForwardRef as ReactComponent };